import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import PublicationSelector from "../parts/PublicationSelector";

// ID 入力は廃止し、出典のみ扱うセクション
export default function SectionIdSource({
  form,
  handleChange,
  publications,
  renderPublicationLabel,
  onShowAddPublication,
  onRefreshPublications,
}) {
  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ color: "teal" }}>
        Source Publication
      </Typography>

      <PublicationSelector
        label="Source of Original Description"
        publicationsData={publications}
        renderOptionLabel={renderPublicationLabel}
        value={form.source_of_original_description}
        onChange={(id) => handleChange("source_of_original_description", id)}
        isRequired={false}
        onRefreshData={onRefreshPublications}
        onShowAdd={onShowAddPublication}
      />

      <TextField
        label="Page in Source"
        value={form.page}
        onChange={(e) => handleChange("page", e.target.value)}
        fullWidth
        margin="dense"
        sx={{ mt: 1 }}
      />
    </Box>
  );
}
